export default "__VITE_ASSET__DSCussaJ__"